import React from 'react';
import PropTypes from 'prop-types';
import { Cushion, Grid, Typography, Space, GridItem } from '@pitchero/react-ui';
import { map } from 'lodash';

const PlayerStatisticsTableKey = ({ keys }) => (
  <Cushion
    horizontal="small"
    top="medium"
    bottom="large"
    className="no-grid-hide"
    responsive={[{ minWidth: 'tab', props: { top: 'large', bottom: 'xlarge' } }]}
  >
    <Grid
      columns="repeat(2, auto)"
      columnGap="xxsmall"
      rowGap="xsmall"
      responsive={[
        {
          minWidth: 'lap',
          props: {
            columns: 'repeat(7, auto)',
            rowGap: 'small',
          },
        },
      ]}
    >
      {map(keys, (keyData, i) => (
        <GridItem key={i}>
          <Space right="small">
            <Typography preset="tag--large" color="black">
              {keyData.key}
            </Typography>
          </Space>
          <Typography preset="description" color="dustygrey">
            {keyData.value}
          </Typography>
        </GridItem>
      ))}
    </Grid>
  </Cushion>
);

PlayerStatisticsTableKey.propTypes = {
  keys: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
    }),
  ).isRequired,
};

export default PlayerStatisticsTableKey;
